import React, { useEffect, useState } from 'react';
import { Provider } from '../forms/utilities/form-context';
import FormItem from '../forms/utilities/form-item';
import ValidationError from '../forms/utilities/validation-error';
import {fire, jsonParse} from '../Libraries/helpers';
import NumberInput from '../forms/inputs/number-input';

const AirExchangeRate = props => {
    const i18n = jsonParse(props.i18n)
    const [airPerformance, setAirPerformance] = useState(500);
    const [roomHeight, setRoomHeight] = useState(2.4);
    const [roomSize, setRoomSize] = useState(41);
    const [results, setResults] = useState({
        airExchangeRate: 0,
    });

    const isValid = () => {
        return (
            !isNaN(airPerformance) &&
            !isNaN(roomHeight) &&
            !isNaN(roomSize)
        );
    };

    const calculateResults = () => {
        if (!isValid()) {
            return;
        }

        const calc = airPerformance / roomHeight / roomSize;

        setResults({
            airExchangeRate: calc.toFixed(1),
        });
    };

    useEffect(() => {
        calculateResults();
    }, [
        airPerformance,
        roomHeight,
        roomSize,
    ]);

    useEffect(() => {
        fire('form-labels::init')
    }, [])

    return (<Provider i18n={ i18n }>
        <div>

            <h2 className={'text-lg font-bold'}>{ i18n.title }</h2>

            <div className="mt-4 flex flex-wrap w-full mt-6">
                <div className="w-full">
                    <FormItem
                        full
                        help={<>m<sup>3</sup>/h</>}
                    >
                        <NumberInput
                            text={ i18n.air_flow_rate }
                            min={ 1 }
                            max={ 10000 }
                            required
                            defaultValue={ airPerformance }
                            onChange={(value) => setAirPerformance(value)}
                            width={'w-full'}
                        />
                    </FormItem>
                </div>
                <div className="w-full">
                    <FormItem
                        full
                        help={<>m</>}
                    >
                        <NumberInput
                            text={ i18n.room_height }
                            min={ 1 }
                            required
                            defaultValue={roomHeight}
                            onChange={(value) => setRoomHeight(value)}
                            width={'w-full'}
                        />
                    </FormItem>
                </div>
                <div className="w-full">
                    <FormItem
                        full
                        help={<>m<sup>2</sup></>}
                    >
                        <NumberInput
                            text={ i18n.room_size }
                            min={ 1 }
                            required
                            defaultValue={roomSize}
                            onChange={(value) => setRoomSize(value)}
                            width={'w-full'}
                        />
                    </FormItem>
                </div>

                {!isValid() && (
                    <div>
                        <ValidationError>
                            { i18n.errors}
                        </ValidationError>
                    </div>
                )}

                {isValid() && (<>

                    <div className={'pt-4 border-t border-green w-full flex items-end justify-between'}>
                        <div className={'block text-grey-700 font-bold'}>{ i18n.air_exchange_rate }</div>
                        <div className={'flex-1 text-right ml-3'}>
                            <span className={'text-green font-bold text-3xl'}>{ results.airExchangeRate }</span>
                            <span className={'text-sm text-grey-700 ml-2'}>{i18n.in_subject}</span>
                        </div>
                    </div>
                </>)}
            </div>
        </div>
    </Provider>
    );
}

export default AirExchangeRate;
